import router from "@/router";
import httpRequest from "@/utils/httpRequest";

export default {
  namespaced: true,
  state: {
    // 页面文档可视高度(随窗口改变大小)
    documentClientHeight: 0,
    // 导航条, 布局风格, defalut(默认) / inverse(反向)
    navbarLayoutType: "default",
    // 侧边栏, 布局皮肤, light(浅色) / dark(黑色)
    sidebarLayoutSkin: "dark",
    // 侧边栏, 折叠状态
    sidebarFold: false,
    // 侧边栏, 菜单
    menuList: [],
    menuActiveName: "",
    // 主入口标签页
    mainTabs: [],
    mainTabsActiveName: "",
    independentData: {},
    userInfo: {},
    brandShow: true,
  },
  mutations: {
    updateDocumentClientHeight(state, height) {
      state.documentClientHeight = height;
    },
    updateSidebarFold(state, fold) {
      state.sidebarFold = fold;
    },
    updateMenuList(state, list) {
      state.menuList = list;
    },
    updateMenuActiveName(state, name) {
      state.menuActiveName = name;
    },
    updateMainTabs(state, tabs) {
      state.mainTabs = tabs;
    },
    updateMainTabsActiveName(state, name) {
      state.mainTabsActiveName = name;
    },
    removeMainActiveTab(state) {
      state.mainTabs = state.mainTabs.filter(
        (item) => item.name !== state.mainTabsActiveName
      );
      if (state.mainTabs.length >= 1) {
        // 当前选中tab被删除
        router.push(
          { name: state.mainTabs[state.mainTabs.length - 1].name },
          () => {
            state.mainTabsActiveName =
              state.mainTabs[state.mainTabs.length - 1].name;
          }
        );
      } else {
        state.menuActiveName = "";
        router.push({ name: "home" });
      }
    },
    setIndependentData(state, data) {
      state.independentData = data;
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
  },
  // TODO: INDEPENDENT
  actions: {
    async independentStationData({ state, commit }) {
      let data;
      if (
        !state.independentData.flag &&
        Object.keys(state.independentData).length > 0
      ) {
        data = state.independentData;
      } else {
        const res = await httpRequest({
          url: httpRequest.adornUrl(
            "/platform/partner/luckSeller/domain/current"
          ),
          method: "get",
          params: httpRequest.adornParams(),
        });
        data = res.data;
      }

      let independentData = {};
      // 删除已有icon图标节点
      const link = document.querySelector("link[rel*='icon']");
      if (link) {
        link.remove();
      }

      // 删除已有title节点
      const title = document.querySelector("title");
      if (title) {
        title.remove();
      }
      if (data) {
        // const independentData = {
        //   countryCode: data.countryCode,
        //   domDomain: data.domDomain,
        //   domName: data.domName,
        //   domFavicon: data.domFavicon,
        //   domLogo: data.domLogo,
        //   domTouRegister: data.domTouRegister,
        //   domTouPrivate: data.domTouPrivate,
        // };
        independentData = data;
        // independentData = {
        //   countryCode: "SG",
        //   domDomain: "glound.asia",
        //   domFavicon: "https://test.mall.fiamp.com/www/favicon.ico",
        //   domLogo:
        //     "https://img.shop.alinkone.com/2023/10/7f92761347e24c5f85b92ccb658c485d.png",
        //   domName: "GLOUND",
        //   flag: false,
        //   domTouPrivate:
        //     '<p style="text-size-adjust: 100%; margin: 0px;">Fiamp平台服务协议</p>\n<p style="text-size-adjust: 100%; margin: 0px;">&nbsp;</p>\n<p style="text-size-adjust: 100%; margin: 0px;">一、导语(개요)</p>\n<p style="text-size-adjust: 100%; margin: 0px;">(一)【审慎阅读】当你点击同意本协议之前，请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向Fiamp客服咨询。</p>\n<p style="text-size-adjust: 100%; margin: 0px;">[신중열독] 본 약정에 동의하기 전에 각 약관의 내용을 반드시 충분히 이해하며, 특히 면제 또는 제한된 책임의 조항, 법률 적용과 쟁의 해결 조항을 포함하여 신중하게 읽어 주십시오. 면제 또는 제한의 조항은 굵은 문자와 밑줄로 표시되므로 &nbsp; 중점적으로 읽어주길 바란다. 만약 당신이 협의에 대해 어떤 의문이 있으면 Fiamp 고객 서비스부문과 문의할 수 있다.</p>\n',
        //   domTouRegister:
        //     '<p style="text-size-adjust: 100%; margin: 0px; color: #676767; font-family: 微软雅黑; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: #ffffff; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">测试修改一、导语(개요)</p>\n<p style="text-size-adjust: 100%; margin: 0px; color: #676767; font-family: 微软雅黑; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: #ffffff; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">(一)【审慎阅读】当你点击同意本协议之前，请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向Fiamp客服咨询。</p>\n<p style="text-size-adjust: 100%; margin: 0px; color: #676767; font-family: 微软雅黑; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: #ffffff; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">[신중열독] 본 약정에 동의하기 전에 각 약관의 내용을 반드시 충분히 이해하며, 특히 면제 또는 제한된 책임의 조항, 법률 적용과 쟁의 해결 조항을 포함하여 신중하게 읽어 주십시오. 면제 또는 제한의 조항은 굵은 문자와 밑줄로 표시되므로 &nbsp; 중점적으로 읽어주길 바란다. 만약 당신이 협의에 대해 어떤 의문이 있으면 Fiamp 고객 서비스부문과 문의할 수 있다.</p>\n',
        // };
        document.title = independentData.domName;
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = independentData.domFavicon;
        document.getElementsByTagName("head")[0].appendChild(link);
        commit("setIndependentData", independentData);
        localStorage.setItem(
          "independentData",
          JSON.stringify(independentData)
        );
      } else {
        independentData = {
          flag: true,
        };
        document.title = "LuckSeller";
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = "https://icon.alinkone.com/favicon/luckseller.ico";
        document.getElementsByTagName("head")[0].appendChild(link);
        commit("setIndependentData", independentData);
        localStorage.setItem(
          "independentData",
          JSON.stringify(independentData)
        );
      }
      return independentData;
    },
    async getNavResult({ state, commit }) {
      let data;
      if (Object.keys(state.userInfo).length > 0) {
        data = state.userInfo;
      } else {
        const res = await httpRequest({
          url: httpRequest.adornUrl("/sys/menu/nav"),
          method: "get",
          params: httpRequest.adornParams(),
        }).catch((err) => {
          console.log(err);
        });
        data = res.data;
      }

      const {
        // authorities, menuList,
        userInfo,
      } = data;
      commit("setUserInfo", userInfo);
      return data;
    },
  },
};
